import { useState } from 'react';

const faqList = [
  {
    q: 'Что такое индивидуальный план развития сотрудника?',
    a: 'Индивидуальный план развития — это конкретный план действий сотрудника по развитию необходимых компетенций. Он фиксирует, что нужно развивать, зачем, какой уровень требуется, какой уровень сейчас, какие действия должен выполнить сотрудник, кто ему помогает, в какие сроки и как будет оцениваться результат.',
  },
  {
    q: 'Зачем нужен ИПР сотруднику и компании?',
    a: 'Сотруднику ИПР даёт понятную траекторию развития и перспективы внутри компании. Компании он позволяет сделать развитие управляемым: связать обучение с задачами бизнеса, готовить кадровый резерв, адресно развивать сотрудников и контролировать прогресс.',
  },
  {
    q: 'Что должно входить в индивидуальный план развития?',
    a: 'В ИПР входят цель развития, конкретная компетенция, текущий и желаемый уровни, конкретные действия, инструменты развития (обучение, наставничество, практика, проекты, коучинг), сроки, ответственные и критерии результата, по которым будет понятно, что компетенция развилась.',
  },
  {
    q: 'Как составить ИПР сотрудника?',
    a: 'Составление ИПР начинается с определения задачи развития, затем оценивается текущий уровень, определяется дефицит, формулируется цель, выбираются инструменты, определяются сроки и критерии результата. После этого план сопровождается, а в конце проводится повторная оценка.',
  },
  {
    q: 'Кто должен составлять индивидуальный план развития?',
    a: 'ИПР формируется совместно: сотрудник отвечает за выполнение действий, руководитель помогает определить приоритеты и создаёт условия для практики, HR/L&D организует систему и инструменты. При необходимости подключаются наставник и тренер или коуч. ИПР, который существует только в HR-системе и не используется руководителем, быстро становится формальным.',
  },
  {
    q: 'Как определить цели развития сотрудника?',
    a: 'Цели развития определяются от задач бизнеса и конкретной роли сотрудника. Сначала понимают, зачем сотруднику развитие, затем оценивают текущий уровень компетенций и определяют разницу между текущим и необходимым уровнем. Цель формулируется как конкретный результат развития, а не как желание «стать лучше».',
  },
  {
    q: 'Как ИПР связан с оценкой компетенций?',
    a: 'Оценка компетенций показывает, что сотрудник уже умеет и каких компетенций не хватает. Именно эта разница между текущим и желаемым уровнем становится основой ИПР: без оценки план строится на предположениях, а не на объективных данных.',
  },
  {
    q: 'Можно ли использовать ИПР после корпоративного обучения?',
    a: 'Да, это один из самых полезных сценариев. После корпоративного обучения ИПР помогает перенести результаты тренинга в рабочую практику: зафиксировать, что конкретно сотрудник будет применять, в каких ситуациях и как будет оцениваться результат.',
  },
  {
    q: 'Какие инструменты развития можно включить в ИПР?',
    a: 'В ИПР можно включать обучение, практику, наставничество, развивающие задачи, коучинг, участие в проектах и самостоятельную работу. Инструмент подбирается под конкретную компетенцию и дефицит, а не наоборот: для одной компетенции нужен тренинг, для другой — практика, для третьей — наставничество.',
  },
  {
    q: 'Как оценивать выполнение индивидуального плана развития?',
    a: 'Выполнение ИПР оценивается по заранее определённым критериям результата. Это может быть демонстрация навыка в реальной рабочей ситуации, обратная связь руководителя, выполнение конкретных действий или повторная оценка компетенции, которая показывает, изменился ли её уровень.',
  },
  {
    q: 'Нужен ли ИПР всем сотрудникам?',
    a: 'Не обязательно. ИПР имеет смысл для сотрудников, которых нужно развивать под конкретную задачу: ключевых специалистов, руководителей, сотрудников кадрового резерва или тех, кого готовят к повышению. Создавать формальные планы для всех сотрудников без задачи развития нецелесообразно.',
  },
  {
    q: 'Как использовать ИПР для кадрового резерва?',
    a: 'Для кадрового резерва ИПР строится вокруг компетенций будущей должности. В план включаются развивающие проекты, наставничество, управленческая практика и подготовка к переходу на новую роль. Так сотрудник системно готовится к будущим обязанностям, а компания снижает риски при назначении.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Часто задаваемые вопросы
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-14 max-w-3xl mx-auto leading-relaxed">
          Ответы на ключевые вопросы об индивидуальных планах развития сотрудников
        </p>

        <div className="space-y-4">
          {faqList.map((item, i) => (
            <div key={i} className="bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-6 py-5 text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4 text-sm md:text-base">{item.q}</span>
                <i className={`ri-arrow-down-s-line text-xl text-teal-600 flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-180' : ''}`}></i>
              </button>
              <div className={`px-6 pb-5 ${openIndex === i ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}